import { Loader2 } from 'lucide-react'

import { cn } from '@/customer/lib/utils'

/** Centred spinner for full-section loading states. */
export function LoadingSpinner({ className }: { className?: string }) {
  return (
    <output
      className={cn('flex items-center justify-center py-12 text-muted-foreground', className)}
      aria-label="Loading"
    >
      <Loader2 className="size-6 animate-spin" />
    </output>
  )
}
